/**
 * Fonte única de verdade para o estilo das Tags do sistema.
 *
 * Padrão canônico ("soft"): fundo claro (bg-*-100) + texto colorido (text-*-700),
 * cantos arredondados médios (border-round-md) e peso de fonte medium.
 *
 * Use sempre o componente <TagBase> passando a prop `cor` com uma das chaves
 * de CORES_TAG. As funções getStatus*Severidade continuam disponíveis para
 * compatibilidade, mas derivam suas classes deste mesmo mapa.
 */

// Chave semântica -> classes de cor (texto + fundo)
export const CORES_TAG = {
    verde: 'text-green-700 bg-green-100',
    vermelho: 'text-red-700 bg-red-100',
    amarelo: 'text-yellow-700 bg-yellow-100',
    roxo: 'text-purple-700 bg-purple-100',
    azul: 'text-blue-700 bg-blue-100',
    cyan: 'text-cyan-700 bg-cyan-100',
    indigo: 'text-indigo-700 bg-indigo-100',
    laranja: 'text-orange-700 bg-orange-100',
    rosa: 'text-pink-700 bg-pink-100',
    cinza: 'text-bluegray-700 bg-bluegray-100',
    preto: 'text-white bg-black-alpha-90',
    primary: 'text-primary-700 bg-primary-100',
};

// Cor usada quando um status não é reconhecido
export const COR_TAG_PADRAO = 'cinza';

/**
 * Monta a string de classes canônica de uma tag a partir de uma cor semântica.
 * @param {string} cor - chave de CORES_TAG
 * @param {{ negrito?: boolean }} [opcoes]
 * @returns {string}
 */
export function classesTag(cor, { negrito = false } = {}) {
    const cores = CORES_TAG[cor] ?? CORES_TAG[COR_TAG_PADRAO];
    const peso = negrito ? 'font-semibold' : 'font-medium';
    return `border-round-md ${peso} ${cores}`;
}

// Mapeia as severidades do PrimeVue para as cores semânticas do sistema
export const SEVERIDADE_PARA_COR = {
    success: 'verde',
    danger: 'vermelho',
    warning: 'amarelo',
    info: 'azul',
    secondary: 'cinza',
    contrast: 'cinza',
};
